import React from "react";
import StoreButton from "../../../components/UI/StoreButton/StoreButton";
import styles from "./ReceivingContent.module.scss";
import classNames from "classnames";

export const ReceivingContent = ({ isAuth = false, openAuthModalFunction }) => {
  const buttonWrapperContent = !isAuth ? (
    <div className={styles.buttonWrapper}>
      <button
        onClick={openAuthModalFunction}
        className={classNames(
          "button",
          "button--primary",
          "button--inline",
          "button--default",
          "button--noradius",
          styles.button
        )}
      >
        Стать участником / Войти
      </button>
    </div>
  ) : null;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.leftColumn}>
            <h2 className={styles.title}>Как получить больше бонусов?</h2>

            <div className={styles.bonusGrid}>
              <div className={styles.bonusItem}>
                <div className={styles.bonusHeader}>
                  <span className={styles.amount}>+ 1 000</span>
                </div>
                <p className={styles.description}>
                  за&nbsp;первую регистрацию в&nbsp;программе лояльности
                </p>
              </div>

              <div className={styles.bonusItem}>
                <div className={styles.bonusHeader}>
                  <span className={styles.amount}>+ 3 000</span>
                </div>
                <p className={styles.description}>
                  в&nbsp;подарок <br/>на&nbsp;День&nbsp;рождения
                </p>
              </div>

              <div className={styles.bonusItem}>
                <div className={styles.bonusHeader}>
                  <span className={styles.amount}>+ 500</span>
                </div>
                <p className={styles.description}>
                  за&nbsp;заполнение всех&nbsp;необходимых <br />
                  полей в&nbsp;личном кабинете
                </p>
              </div>

              <div className={styles.bonusItem}>
                <div className={styles.bonusHeader}>
                  <span className={styles.amount}>+ 500</span>
                </div>
                <p className={styles.description}>
                  за&nbsp;первую установку мобильного приложения
                </p>
              </div>
            </div>

            <div className={styles.appSection}>
              <div className={styles.appButtons}>
                <StoreButton store="apple" />
                <StoreButton store="google" />
              </div>
              <div className={styles.phoneImageLeft}>
                <img src="/files/images/bonus-program/phone.png" alt="" />
              </div>
            </div>
            
             <div className={styles.leftColumnButtonWrapper}>
              {buttonWrapperContent}
             </div>
          </div>

          <div className={styles.rightColumn}>
            <div className={styles.mainImageWrapper}>
              <picture>
                <source
                  media="(max-width: 640px)"
                  srcSet="/files/images/bonus-program/receiving-content-2-mobile.png"
                />

                <img
                  className={styles.mainImage}
                  src="/files/images/bonus-program/receiving-content-2-desktop.png"
                  alt="YOU WANNA Club"
                />
              </picture>
            </div>
          </div>
        </div>
        {buttonWrapperContent}
      </div>
    </section>
  );
};
